"use strict";

/******************************************************************************
** ControlClassRepository
*/

let ControlClassRepository = new class {

	constructor() {
		this._classMap = {};
	}

	find($name) {
		return this._classMap[$name];
	}

	register($name, $type) {
		//let $name = $type.name;
		this._classMap[$name] = $type;
		return $type;
	}

}

export default ControlClassRepository;



/** WEBPACK FOOTER **
 ** ./forms/ControlClassRepository.js
 **/